<template>
	<fragment>
		<common-header
			subname="사이트관리"
			name="사이트항목 목록"
			v-bind:searchbox="true"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:initKeyword="keyword"
			@keywordChanged="searchByKeyword"
		></common-header>

		<section ref="container" class="container">
			<common-side-menu :menus="sideMenus" :btnList="sideButtons"></common-side-menu>

			<div class="container-fiuld clearfix" v-if="selectedBoard">
				<div class="title-box m-b-30 b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">
						{{selectedBoard.boardName}}
						<a class="modify" @click="routerBoardModify"></a>
						<a class="del" @click="deleteBoard"></a>
					</div>
				</div>
				
				<!-- <div class="title-box m-b-30 clearfix">
					링크: {{link}}
					<a class="btn-sm btn-blue round" :href="link" target="_blank">이동하기</a>
				</div> -->
				<div class="btn-group-box clearfix">
					<!--div class="btn-group pull-left clearfix">
						<div class="select pull-left m-r-5">
							<a class="btn btn-red round" href="#" onclick="$('#plus-modal').show()">
								<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="17" height="20" viewBox="0 0 17 20">
									<path class="recycle"
										d="M510.213,1255.71h1.574v8.16h-1.574v-8.16Zm3.148,0h1.574v8.16h-1.574v-8.16Zm-6.3,0h1.574v8.16h-1.574v-8.16Zm10.074-5.86h-2.4v-0.51a2.353,2.353,0,0,0-2.361-2.34h-2.755a2.354,2.354,0,0,0-2.361,2.34v0.51h-2.4a2.353,2.353,0,0,0-2.361,2.34v1.96h1.574v10.51a2.353,2.353,0,0,0,2.361,2.34h9.13a2.353,2.353,0,0,0,2.361-2.34v-10.51H519.5v-1.96A2.353,2.353,0,0,0,517.139,1249.85Zm-8.3-.51a0.784,0.784,0,0,1,.787-0.78h2.755a0.784,0.784,0,0,1,.787.78v0.51h-4.329v-0.51Zm7.517,15.32a0.784,0.784,0,0,1-.787.78h-9.13a0.784,0.784,0,0,1-.787-0.78v-10.51h10.7v10.51Zm1.574-12.07H504.074v-0.4a0.784,0.784,0,0,1,.787-0.78h12.278a0.784,0.784,0,0,1,.787.78v0.4Z"
										transform="translate(-502.5 -1247)"></path>
								</svg> 삭제
							</a>
						</div>
					</div-->
					<!-- //end .btn-group -->
					<!-- //end .btn-group -->
					<table class="table2 table-hover text-center" style="border-collapse: separate;border-spacing: 0 10px !important;">
						<thead>
							<tr class="bg-lightgray">
								<!--th>
									<input id="table-allcheck" class="checkbox" type="checkbox" :checked="allSelected" @change="selectAll">
									<label for="table-allcheck">체크버튼</label>
								</th-->
								<th class="w20">#</th>
								<!-- <th class="w40">분류</th> -->
								<th class="w220">제목</th>
								<th class="w100">작성자</th>
								<th class="w40">작성일</th>
								<!-- <th class="w40">조회</th> -->
								<th class="w20">관리</th>
							</tr>
						</thead>
						<vue-draggable tag="tbody" handle=".handle" 
							@end="dragEnd($event)" v-model="articles">
							<template v-for="article in articles" >
								<tr v-bind:style="{'background-color': article.backgroundColor}" :key="`article-id-${article.articleId}`">
								<td>
									{{!article.noticeEnable && totalCount - offset - article.num || "공지"}}
								</td>
								<td v-bind:style="{'text-align': 'left', 'color': article.nameColor }">
									<a @click="routerArticle(article)">
										<span v-for="(i, idx) in new Array(article.depth || 0)" :key="'space-for-'+article.articleId+'-'+idx" class="m-r-10"></span>
										<span v-if="article.depth"><img src="images/re.png"> [답글] </span> 
										<span class="m-r-5">{{article.title}}</span>  
										<img src="images/ic_file2.png" v-if="article.articleFileMappingList.length"/>
									</a>
								</td>
								<td>
									{{article.mber && article.mber.mberName || article.name}}<br>{{article.mberId && `(${article.mberId})`|| ""}}
								</td>
								<td>
									{{article.regDate}}
								</td>
								<!-- <td>
									{{article.lookupCount}}
								</td> -->
								<td>
									<a class="move m-r-5 handle">위치 이동</a>
								</td>
							</tr>
						</template>
						</vue-draggable>
					</table>

					<ctrl-pagination :currentPage="offset / pageSize + 1"
						:pageSize="pageSize" :totalCount="totalCount"
						:key="hash({pageSize, offset, totalCount})"
						@pageChanged="onPageChanged"></ctrl-pagination>
				</div>
			</div>
		</section>

		<common-footer></common-footer>

		<modal-confirm :config="modals.ModalConfirm" @yes="modals.ModalConfirm.show=false" @no="modals.ModalConfirm.show=false" :key="hash(modals.ModalConfirm)"></modal-confirm>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import CommonHeader from '../components/CommonHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
import CommonSideMenu from '../components/CommonSideMenu.vue'
import CtrlPagination from '../components/CtrlPagination.vue'
import ModalConfirm from '../modals/ModalConfirm.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import VueDraggable from 'vuedraggable'

import Axios from 'axios'
import server from '../statics/server'

export default {
	// 컴포넌트 명칭
	name: "ViewSiteList",
	mixins: [fnAdjustHeight],
	mounted: function() {
		this.getBoardList()
		this.getArticlList();
	},

	components: {
		CommonHeader,
		CommonFooter,
		CommonSideMenu,
		CtrlPagination,
		ModalConfirm,
		ModalAlert,
		VueDraggable
	},

	// 이 컴포넌트에서 사용할 내부데이터
	data: function() {
		return {
			modals: {
				ModalConfirm: ModalConfirm.default(),
				ModalAlert: ModalAlert.default(),
			},
			menus: [
				{name: '사이트항목 목록', link: "/site", selected: true},
				{name: '로그 관리', link: "/log", selected: false},
			],
			buttons: [
				{name: '사이트항목 작성', fn: () => {
					if(!this.$route.params.boardId) {
						this.modals.ModalAlert.msg = "사이트를 선택해 주세요";
						this.modals.ModalAlert.show = true;
					}
					else this.$router.push(`/site/${this.$route.params.boardId}/write`);
				}},
				// {name: '사이트 만들기', fn: () => {
				// 	this.$router.push("/site/register");
				// }},
			],
			server,
			link: "",
			sideButtons: [],
			sideMenus: [],
			selectedBoard: null,
			articles: [],
			keyword: this.$route.query.keyword || "",
			totalCount: 0,
			pageSize: parseInt(this.$route.query.pageSize) || 30,
			offset: parseInt(this.$route.query.offset) || 0,
		}
	},

	// 이 컴포넌트에서 구현할 기능
	methods: {
		routerArticle: function(article) {
			const { offset, pageSize, keyword } = this;
			this.$router.push(`/site/${article.boardId}/detail/${article.articleId}${`?offset=${parseInt(offset)}`}${`&pageSize=${parseInt(pageSize)}`}${keyword && `&keyword=${keyword}` || ''}`);
		},
		routerBoardList: function() {
			this.$router.push('/site');
		},
		routerBoardModify: function() {
			const { selectedBoard } = this;
			this.$router.push(`/site/${selectedBoard.boardId}/modify`);
		},
		getBoardList: async function() {
			try {
				const {data} = await Axios.post(`${server.addr()}${server.api.SITE}`, { lecId: 0 })
				let { boardId } = this.$route.params;

				this.sideMenus = data.list.map(e => {
					if(e.boardId === parseInt(boardId)) {
						this.selectedBoard = e;
						this.link = `${server.addr()}/user/site.html?state=1&lecId=${e.lecId}&boardId=${e.boardId}`;
					}
					if(!boardId) {
						this.selectedBoard = e;
						boardId = e.boardId;
						this.$router.push("/site/"+e.boardId);
					}
					return {
						board: e,
						selected: e.boardId === boardId,
						name: e.boardName+(e.hideEnable?" (감춤상태)":""),
						link: "/site/"+e.boardId
					}
				});
			} catch(e) {e}
		},
		getArticlList: async function() {
			try {
				const { keyword, offset, pageSize } = this;
				const { boardId } = this.$route.params;
				if(!boardId) return;

				const { data } = await Axios.post(`${server.addr()}${server.api.SITE_ARTICLE}`, {
					boardId, pageSize, offset, keyword
				});
				data.list.map((e,idx) => { e.num = idx; e.noticeEnable = false});
				
				this.articles = data.list.map(e=>{ 
					e["selected"] = false;
					if(e.noticeEnable) {
						e["nameColor"] = "#f08300";
						e["backgroundColor"] = "#f8f8f8";
					}
					return e; 
				});

				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				// TODO : error exception
			}
		},
		searchByKeyword: function(keyword) {
			const { pageSize } = this;
			this.offset = 0;
			this.keyword = keyword;
			this.$router.replace({ query: {offset: this.offset, pageSize, keyword} });
			this.getArticlList();
		},
		onPageChanged: function(page) { // 페이지네이션 이벤트 핸들러
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;
			this.$router.replace({ query: {offset: this.offset, pageSize} });
			this.getArticlList();
		},
		deleteBoard: function() {
			this.modals.ModalConfirm.msg = "정말 사이트을 삭제하시겠습니까?";
			this.modals.ModalConfirm.btnYes.name = "취소";
			this.modals.ModalConfirm.btnYes.fn = () => { this.modals.ModalConfirm.show = false; };
			this.modals.ModalConfirm.btnNo.name = "사이트 삭제";
			this.modals.ModalConfirm.btnNo.fn = () => {
				Axios.delete(server.addr()+server.api.SITE+"/"+this.$route.params.boardId).then(() => {
					this.modals.ModalConfirm.show = false;
					this.modals.ModalAlert.msg = "사이트이 삭제되었습니다.";
					this.modals.ModalAlert.btn.fn = () => {
						this.$router.push("/site");
					}
					this.modals.ModalAlert.show = true;
				})
			}
			this.modals.ModalConfirm.show = true;
		},
		dragEnd: async function($event) {
			const { articles } = this;
			const { newIndex, oldIndex } = $event;
			const targetArticleId = articles[newIndex].articleId;
			let dst = 0;
			if(newIndex !== (articles.length - 1)) {
				const dstArticle = articles[oldIndex];
				dst = dstArticle.articleId;
			}
			try {
				await Axios.patch(`${server.addr()}${server.api.SITE_ARTICLE}/${targetArticleId}`, {
					dst
				});
			} catch(e) {
				// TODO: error exception
			}
		}
	},
	computed: {
		allSelected: function() {
			const isAllSelected = this.articles.reduce((prev, curr) => prev && curr.selected , true);
			return isAllSelected;
		}
	}
}
</script>

<style scoped>
.recycle {
	fill: #fff;
	fill-rule: evenodd;
}

.btn-group .btn:hover .recycle {
	fill: #fff;
	fill-rule: evenodd;
}
</style>
